import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';
import type { Interpolation } from '@mui/styled-engine';

export const fab: OverWritable = {
  MuiFab: {
    defaultProps: {
      color: 'primary',
    },

    variants: [
      {
        props: { color: 'default' },
        style: ({ theme }): Interpolation<unknown> => {
          const isLight = isLightTheme(theme);

          return {
            color: isLight
              ? theme.palette.common.white
              : theme.palette.grey[800],
            backgroundColor: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: isLight
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
            },
          };
        },
      },
      {
        props: { color: 'inherit' },
        style: ({ theme }) => {
          const isLight = isLightTheme(theme);

          return {
            backgroundColor: !isLight && theme.palette.grey[700],
            '&:hover': {
              backgroundColor: isLight
                ? theme.palette.grey[400]
                : theme.palette.grey[600],
            },
          };
        },
      },
    ],
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.customShadows.z8,
        '& svg': { width: 24, height: 24 },
        '&:hover': { boxShadow: 'none' },
      }),
      primary: ({ theme }) => ({
        boxShadow: theme.customShadows.primary,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      }),
      secondary: ({ theme }) => ({
        boxShadow: theme.customShadows.secondary,
        '&:hover': {
          backgroundColor: theme.palette.secondary.dark,
        },
      }),
      extended: ({ theme }) => ({
        '& svg': {
          marginRight: theme.spacing(1),
        },
      }),
    },
  },
};
